import { lazy } from "react";
import type { AppRouteObject } from "../../routes";

const PendingListingPage = lazy(() => import("../PendingListingPage"));

export const PendingListingRoute: AppRouteObject = {
  path: "/:realm/pending-listing",
  element: <PendingListingPage />,
  breadcrumb: (t) => t("titleUsers"),
  handle: {
    access: "query-users",
  },
};
